// import React, { createContext, useContext, useState } from "react";

// const PTagFormContext = createContext();

// export function usePTagForm() {
//   return useContext(PTagFormContext);
// }

// export function PTagFormProvider({ children }) {
//   const [form, setForm] = useState({
//     version: "",
//     size: "",
//     color: "",
//     petName: "",
//     petPhone: "",
//     photo: null,
//     recipient: "",
//     recipientPhone: "",
//     recipientEmail: "",
//     shippingMethod: "",
//     shippingAddress: "",
//     payment: "fps",
//     coupon: "",
//     price: 0,
//     pendingStatus: "",
//     option: "",
//     attrName: "",
//     petContact: "",
//     netCode: "",
//     serviceName: "",
//   });

//   return (
//     <PTagFormContext.Provider value={{ form, setForm }}>
//       {children}
//     </PTagFormContext.Provider>
//   );
// }




import React, { createContext, useContext, useState } from "react";

// Default empty form
const initialForm = {
  version: "",
  size: "",
  color: "",
  petName: "",
  petPhone: "",
  photo: null,
  recipient: "",
  recipientPhone: "",
  recipientEmail: "",
  shippingMethod: "",
  shippingAddress: "", 
  payment: "fps",
  paymentWay: "",
  coupon: "",
  price: 0,
  pendingStatus: "",
  option: "",
  attrName: "",
  petContact: "",
  netCode: "",
  serviceName: "",
  tempId: "",
  delivery: "",
};

const PTagFormContext = createContext(undefined);

export function usePTagForm() {
  const context = useContext(PTagFormContext);
  if (!context) {
    throw new Error("usePTagForm must be used within PTagFormProvider");
  }
  return context;
}

export function PTagFormProvider({ children }) {
  const [forms, setForms] = useState([initialForm]);
  const [activeFormIndex, setActiveFormIndex] = useState(0);
  const [formsAdded, setFormsAdded] = useState(0);
  const [orderConfirmed, setOrderConfirmed] = useState(false);

  // Add a new blank form and make it active
  const addForm = () => {
    setForms(prev => {
      const base = prev[0] || {};
      // Copy only the fields you want to synchronize
      return [
        ...prev,
        {
          ...initialForm, // your default form shape
          attrName: base.attrName,
          delivery: base.delivery,
          email: base.email,
          lastName: base.lastName,
          netCode: base.netCode,
          payment: base.payment,
          paymentWay: base.paymentWay,
          address: base.address,
          phoneNumber: base.phoneNumber,
          shippingAddress: base.shippingAddress,
          serviceName: base.serviceName,
        }
      ];
    });
    setActiveFormIndex(forms.length); // new form becomes active
  };

  // Remove form by index (prevent removing last one if you want)
  const removeForm = (index) => {

    setForms((prev) => prev.filter((_, i) => i !== index));

    // Adjust active index if needed
    if (activeFormIndex >= forms.length - 1) {
      setActiveFormIndex(Math.max(0, forms.length - 2));
    } else if (activeFormIndex > index) {
      setActiveFormIndex(activeFormIndex - 1);
    }
  };

  // Update entire form at index
  const updateForm = (index, newFormData) => {
    setForms((prev) =>
      prev.map((form, i) => (i === index ? newFormData : form))
    );
  };

  const incrementFormsAdded = () => {
    setFormsAdded(formsAdded + 1);
  };

  const decrementFormsAdded = () => {
    setFormsAdded(Math.max(0, formsAdded - 1));
  };

  const removeAllFormsAdded = () => {
    setFormsAdded(0);
  };

  const setOrderConfirmedTrue = () => {
    setOrderConfirmed(true);
  };

  // Helper: update only part of the active form (just like your old setForm)
  const setForm = (updater) => {
    setForms((prev) =>
      prev.map((form, i) =>
        i === activeFormIndex
          ? typeof updater === "function"
            ? updater(form)
            : updater
          : form
      )
    );
  };

  // Current active form (for backward compatibility)
  const form = forms[activeFormIndex] || initialForm;

  const value = {
    forms,              // all forms array
    form,               // current active form (backward compatible!)
    setForm,            // update current form (works exactly like before!)
    activeFormIndex,
    setActiveFormIndex,
    addForm,
    removeForm,
    updateForm,
    removeAllForms: () => setForms([]),
    totalForms: forms.length,
    incrementFormsAdded,
    decrementFormsAdded,
    removeAllFormsAdded,
    formsAdded,
    setOrderConfirmedTrue,
    orderConfirmed,
  };

  return (
    <PTagFormContext.Provider value={value}>
      {children}
    </PTagFormContext.Provider>
  );
}